import { Component, inject } from '@angular/core';
import { RegisterAreaService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  RegisterAreaCreateDto,
  RegisterAreaDto,
  RegisterAreaExcelDownloadDto,
  RegisterAreaUpdateDto,
} from '../proxy/planning/dtos/register-area';
import { REGISTERAREA_CONFIG, REGISTERAREA_FIELDS } from './register-area.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-register-area',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, RegisterAreaService, ConfirmationService],
  templateUrl: './register-area.html',
  styleUrl: './register-area.scss',
})
export class RegisterArea extends BaseCrudComponent<
  RegisterAreaDto,
  RegisterAreaCreateDto,
  RegisterAreaUpdateDto,
  RegisterAreaExcelDownloadDto
> {
  service = inject(RegisterAreaService);
  config = REGISTERAREA_CONFIG;
  fields = REGISTERAREA_FIELDS;

  protected prepareUpdateDto(data: any, selected: RegisterAreaDto): RegisterAreaUpdateDto {
    return {
      date: data.date,
      generalNumber: data.generalNumber,
      generalArea: data.generalArea,
      productivityNumber: data.productivityNumber,
      productivityArea: data.productivityArea,
      nativeNumber: data.nativeNumber,
      nativeArea: data.nativeArea,
      protectorNumber: data.protectorNumber,
      protectorArea: data.protectorArea,
      woodQualityNumber: data.woodQualityNumber,
      woodQualityArea: data.woodQualityArea,
      notes: data.notes,
      plantationDate: data.plantationDate,
      planNumber: data.planNumber,
      registerId: data.registerId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'RegisterArea';
  }
}
